export const T19_06 = {
    "selectedValueColumn": "CustomerGroup",
    "selectedTitle": "Channel",
    "visual": [
        {
            "columns": 12,
            "rows": 2,
            "visual": {
                "id": 1,
                "type": "advancedTable",
                "colorTheme": "colorTheme1",
                "title": "Channel",
                "binding": {
                    "data": {
                        "columns": [
                            {
                                "name": 'Channel Code',
                                "columnName": 'DistributorCode',
                                "width": '150px',
                                "align": "left",
                                "sortable": true,
                                "sum": false,
                            },
                            {
                                "name": 'Channel Name',
                                "columnName": 'DistributorName',
                                "width": '300px',
                                "align": "left",
                                "sortable": true,
                                "sum": false,
                            },
                            {
                                "name": 'Actual Sales',
                                "columnName": 'ActualSales',
                                "width": '140px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'LY Sales',
                                "columnName": 'LYSales',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'Growth %',
                                "columnName": 'Growth',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                            }
                        ],
                        "title": 'CustomerName',
                        "endpoint": "T19.6",
                        "parameters": [
                            { "key": "FromMonth", "value": "2024" },
                            { "key": "FromYear", "value": "1" },
                            { "key": "ToMonth", "value": "2024" },
                            { "key": "ToYear", "value": "1" },
                            { "key": "AgentCode", "value": "" },
                            { "key": "CustomerGroup", "value": "" },
                            { "key": "ConfigTypeCode", "value": "" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {
                                "selectedValueColumn": "CustomerGroupDistributorCode",
                                "selectedTitle": "Customer",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "Customer",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Customer Name',
                                                            "columnName": 'CustomerName',
                                                            "width": '400px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        },
                                                        {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true,
                                                        },
                                                        {
                                                            "name": 'LY Sales',
                                                            "columnName": 'LYSales',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true,
                                                        },
                                                        {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'CustomerName',
                                                    "endpoint": "T19.7",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "AgentCode", "value": "" },
                                                        { "key": "CustomerGroupDistributorCode", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {
                                                            "selectedValueColumn": "CustomerGroupDistributorCustomer",
                                                            "selectedTitle": "Product",
                                                            "visuals": [
                                                                {
                                                                    "title": "PESO",
                                                                    "visual": [
                                                                        {
                                                                            "columns": 12,
                                                                            "rows": 2,
                                                                            "visual": {
                                                                                "id": 1,
                                                                                "type": "advancedTable",
                                                                                "colorTheme": "colorTheme1",
                                                                                "title": "Product Name",
                                                                                "binding": {
                                                                                    "data": {
                                                                                        "columns": [
                                                                                            {
                                                                                                "name": 'Product Name',
                                                                                                "columnName": 'ItemName',
                                                                                                "width": '400px',
                                                                                                "align": "left",
                                                                                                "sortable": true,
                                                                                                "sum": false,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Actual Sales',
                                                                                                "columnName": 'ActualSales',
                                                                                                "width": '140px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'LY Sales',
                                                                                                "columnName": 'LYSales',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Growth %',
                                                                                                "columnName": 'Growth',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": false,
                                                                                                "percent": true
                                                                                            }
                                                                                        ],
                                                                                        "title": 'ItemName',
                                                                                        "endpoint": "T19.8",
                                                                                        "parameters": [
                                                                                            { "key": "FromMonth", "value": "" },
                                                                                            { "key": "FromYear", "value": "" },
                                                                                            { "key": "ToMonth", "value": "" },
                                                                                            { "key": "ToYear", "value": "" },
                                                                                            { "key": "AgentCode", "value": "" },
                                                                                            { "key": "CustomerGroupDistributorCustomer", "value": "" },
                                                                                            { "key": "ConfigTypeCode", "value": "" }
                                                                                        ]
                                                                                    },
                                                                                    "context": {
                                                                                        "point": {
                                                                                            "onClick": {

                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "title": "UNIT",
                                                                    "visual": [
                                                                        {
                                                                            "columns": 12,
                                                                            "rows": 2,
                                                                            "visual": {
                                                                                "id": 1,
                                                                                "type": "advancedTable",
                                                                                "colorTheme": "colorTheme1",
                                                                                "title": "Product Name",
                                                                                "binding": {
                                                                                    "data": {
                                                                                        "columns": [
                                                                                            {
                                                                                                "name": 'Product Name',
                                                                                                "columnName": 'ItemName',
                                                                                                "width": '400px',
                                                                                                "align": "left",
                                                                                                "sortable": true,
                                                                                                "sum": false,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Actual Sales',
                                                                                                "columnName": 'ActualSales',
                                                                                                "width": '140px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'LY Sales',
                                                                                                "columnName": 'LYSales',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Growth %',
                                                                                                "columnName": 'Growth',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": false,
                                                                                                "percent": true
                                                                                            }
                                                                                        ],
                                                                                        "title": 'ItemName',
                                                                                        "endpoint": "T19.9",
                                                                                        "parameters": [
                                                                                            { "key": "FromMonth", "value": "" },
                                                                                            { "key": "FromYear", "value": "" },
                                                                                            { "key": "ToMonth", "value": "" },
                                                                                            { "key": "ToYear", "value": "" },
                                                                                            { "key": "AgentCode", "value": "" },
                                                                                            { "key": "CustomerGroupDistributorCustomer", "value": "" },
                                                                                            { "key": "ConfigTypeCode", "value": "" }
                                                                                        ]
                                                                                    },
                                                                                    "context": {
                                                                                        "point": {
                                                                                            "onClick": {

                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ],
                            }
                        }
                    }
                }
            }
        }
    ],
}